<div class="ac-badge" [ngClass]="'ac-badge-color-' + color">
    <ng-content></ng-content>
</div>